'use es6';

export const NONE = 'NONE';
export const BODY_CSS = 'BODY_CSS';
export const ENABLE_DOMAIN_STYLESHEET = 'ENABLE_DOMAIN_STYLESHEET';
export const ATTACH_STYLESHEET = 'ATTACH_STYLESHEET';
export const ATTACH_JAVASCRIPT = 'ATTACH_JAVASCRIPT';
export const HEAD_HTML = 'HEAD_HTML';
export const FOOT_HTML = 'FOOT_HTML';
export const VIRTUAL_BODY = 'VIRTUAL_BODY';